import { Outlet } from "react-router-dom";

import Breadcrumb from "../common/breadcrumbs";
import { Footer } from "./Footer/index";
import Header from "./header";
import Navbar from "./navbar";

const Layout = () => {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <Header />
      <Breadcrumb />
      <div className="relative flex min-h-0 flex-1">
        <Navbar className="shrink-0" />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      <Footer />
    </div>
  );
};
export default Layout;
